module.exports = {"621124100":"洮阳镇","621124101":"八里铺镇","621124102":"新添镇","621124103":"辛店镇","621124104":"太石镇","621124105":"中铺镇","621124106":"峡口镇","621124107":"龙门镇","621124108":"窑店镇","621124109":"玉井镇","621124110":"衙下集镇","621124111":"南屏镇","621124200":"红旗乡","621124201":"上营乡","621124202":"康家集乡","621124203":"站滩乡","621124204":"漫洼乡","621124205":"连儿湾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621124.json
// module id = 3090
// module chunks = 0